import { render, staticRenderFns } from "./RecycleBinView.vue?vue&type=template&id=c4d688fe&scoped=true"
import script from "./RecycleBinView.vue?vue&type=script&lang=js"
export * from "./RecycleBinView.vue?vue&type=script&lang=js"
import style0 from "./RecycleBinView.vue?vue&type=style&index=0&id=c4d688fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d688fe",
  null
  
)

export default component.exports